import React, { Component, PropTypes } from 'react';
import classNames from 'classnames';
import {TransitionMotion, spring, presets} from 'react-motion';

import Col from './Col';


class PageLeft extends Component {

    static propTypes = {
        className: React.PropTypes.string,
        children: React.PropTypes.node
    };


    getStartValue() {
        return {
            sideBar: {
                opacity: spring(0, [100,40])
            }
        };
    }

    getEndValue() {
        return {
            sideBar: {
                opacity: spring(1, [100,40])
            }
        };
    }

    render() {
        let classes = {};

        let {className, children, ...props} = this.props;

        return (
            <div className={classNames(classes, className)} {...props}>
                <Col s={12} m={3}>

                    <TransitionMotion defaultStyles={this.getStartValue()}
                                      styles={this.getEndValue()}
                    >
                        {configs =>
                            <div className="page-left" style={configs.sideBar}>
                                {children}
                            </div>
                        }
                    </TransitionMotion>


                </Col>
            </div>
        );
    }
}

export default PageLeft;